import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useAuthDataContext } from './Auth'
import { useSocketContext } from './Socket'

export const VoiceCallContext = createContext({})

const MAX_CALLS = 4
const CALL_TTL = 10000

const VoiceCallProvider = props => {

    const auth = useAuthDataContext();
    const listener = useSocketContext();
    const pid = auth.partnerId();

    const [state, setState] = useState({
        list: [
            // {
            //     id: 1,
            //     call_id: 1,
            //     caller_id: '+35988888888',
            // }
        ]
    });

    const stateRef = useRef(state.list);

    const setStateRef = data => {
        stateRef.current = data;

        setState({
            list: data
        });
    }

    const close = id => {
        let data = stateRef.current;

        let filtered = data.filter(c => Number(c.call_id) !== Number(id));

        setStateRef(filtered);
    }

    useMemo(() => {

        if (pid) {

            listener.private(`voicecall.${pid}`)
                .listen('IncommingCall', e => {
                    console.log('IncommingCall')
                    console.log(e);

                    let expiresAt = Date.now() + CALL_TTL;

                    let incoming = [].concat(e.call).map(c => ({ ...c, expiresAt }));

                    // keep only the newest MAX_CALLS so the list can't overflow the screen
                    let data = stateRef.current.concat(incoming).slice(-MAX_CALLS);

                    setStateRef(data);
                })
                .listen('HangupCall', e => {
                    console.log(e);

                    let data = stateRef.current;

                    let filtered = data.filter(c => c.call_id !== e.call.call_id);

                    setStateRef(filtered);
                });

        }

    }, []);

    // Remove expired calls based on a timestamp instead of a per-item
    // setTimeout, since timers are throttled/paused while the tab is not
    // focused. The sweep also runs on visibilitychange, so everything already
    // past its TTL is cleared as soon as the tab regains focus.
    useEffect(() => {

        const sweep = () => {
            let now = Date.now();
            let data = stateRef.current;
            let filtered = data.filter(c => !c.expiresAt || c.expiresAt > now);

            if (filtered.length !== data.length) {
                setStateRef(filtered);
            }
        }

        const interval = setInterval(sweep, 1000);
        document.addEventListener('visibilitychange', sweep);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', sweep);
        }

    }, []);

    const data = useMemo(() => ({
        ...state, close
    }), [state]);

    return <VoiceCallContext.Provider value={data} {...props} />
}

export const useVoiceCallContext = () => useContext(VoiceCallContext);

export default VoiceCallProvider;